import styles from './CmsVimeo.module.scss';
import Vimeo from '@components/components/Vimeo/Vimeo';
import React from 'react';

const CmsVimeo = props => <Vimeo {...props} className={styles.vimeoVideo} />;

export default CmsVimeo;
